import * as Yup from 'yup';
import DateFormatter from 'components/DateFormatter';
import { currencyToLocal } from 'utils/constants';

/* eslint-disable react/react-in-jsx-scope */
export const indianSubscriptionPlansColumns = [
  { accessorKey: 'planName', header: 'PLAN', sort: true },
  {
    accessorKey: 'price',
    header: 'AMOUNT',
    enableSorting: true,
    cell: ({ row }) => {
      return (
        <div>
          {currencyToLocal(row?.original?.price, row?.original?.currency)}
        </div>
      );
    },
  },
  {
    accessorKey: 'discountedAmount',
    header: 'DISCOUNTED AMOUNT',
    enableSorting: true,
    cell: ({ row }) => {
      return (
        <div className="info text-end me-4">
          <h4 className="f-12 fw-medium mb-0 text-dark ">
            {currencyToLocal(
              row?.original?.discountedAmount,
              row?.original?.currency,
            )}
          </h4>
          <p className="mb-0 mt-1 f-12 font-manrope text-active ">
            {row?.original?.discountedPercentage}%
          </p>
        </div>
      );
    },
  },
  {
    accessorKey: 'duration',
    header: 'DURATION',
    cell: ({ row }) => <>{row?.original?.duration} days</>,
    sort: true,
  },
  { accessorKey: 'status', header: 'STATUS', enableSorting: false },

  {
    accessorKey: 'createdAt',
    header: 'CREATED DATE',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    sort: true,
  },
  {
    accessorKey: 'updatedAt',
    header: 'LAST MODIFIED DATE',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.updatedAt} />,
    sort: true,
  },

  // {
  //   accessorKey: 'subscribers',
  //   header: 'SUBSCRIBERS',
  //   enableSorting: true,
  // },
  { accessorKey: 'actions', header: '', enableSorting: false },
];

export const subscriptionPlanValidationSchema = Yup.object().shape({
  planName: Yup.string().required('Plan Name is required'),
  price: Yup.number().required('Price is required'),
  description: Yup.string().required('Description is required'),
  status: Yup.string().required('Status is required'),
});
